import type { TenantConfig } from '@/types/TenantConfig'

const orange = '#F9A203'
const green = '#A6B82C'
const beige = '#F1EEDE'
const grey = 'rgba(0, 0, 0, 0.07)'
const darkGrey = '#656667'

export const dbg: TenantConfig = {
  logo: 'assets/dbg/static/logo.svg',
  themeOptions: {
    primaryColor: orange,
    secondaryColor: orange,
    footerBackgroundColor: beige,
    footerTextColor: 'black',
    logoHeight: '110px',
    cartHeaderBackgroundColor: beige,
    cartHeaderTextColor: darkGrey,
    headerTopBorder: `10px solid ${green}`,
    headerBottomBorder: `1px solid ${grey}`,
    headerDropShadow: `0 4px 10px ${grey}`,
    headerHeight: '130px',
    memberLinksColor: darkGrey,
    memberLinksColorHover: green,
  },
  componentOptions: {
    stripeCreditCard: {
      fontFaceStylesheet: 'https://use.typekit.net/tsu4pxd.css',
    },
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/dbg/static/completed.jpg',
      },
      completedContentOffset: {
        desktop: '-200px',
        mobile: '-150px',
      },
    },
  },
}
